"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Button = _styledComponents.default.button.withConfig({
  componentId: "sc-1v62o0r-0"
})(["background:0;border:0;padding:0;margin:0;text-align:inherit;cursor:pointer;color:inherit;text-decoration:none;&[disabled]{cursor:not-allowed;}"]);
/**
 * Use when a button is needed for accessibility purposes but no button styles are desired.
 */


const A11y = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(Button, _extends({
  ref: ref,
  tabIndex: "0",
  as: props.disabled ? "button" : props.href ? "a" : "button"
}, props), props.children));

A11y.displayName = "A11y";
A11y.defaultProps = {
  type: "button"
};
A11y.propTypes = {
  /** The button contents */
  children: _propTypes.default.node.isRequired,

  /** The type of the button */
  type: _propTypes.default.oneOf(["submit", "reset", "button"]),

  /** If the button should be disabled */
  disabled: _propTypes.default.bool,

  /** The link that the button should navigate to on click */
  href: _propTypes.default.string
};
var _default = A11y;
exports.default = _default;